var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"main-content row mx-0"},[(_vm.showDashboard)?_c('DashboardSidebar',{staticClass:"col-md-2 mt-3 desktop-only"}):_vm._e(),_c('div',{staticClass:"col-12 px-0",class:{'col-md-10 mt-4': _vm.showDashboard}},[_vm._t("default")],2)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }